<page-data-manager>
  <div class="row">
    <div class="col-xs-12">
      <div class="page-header">
        <h2 ng-show="newUsuario.id">Editando Usuário</h2>
        <h2 ng-hide="newUsuario.id">Novo Usuário</h2>
      </div>
      <ng-include src="'views/usuarios/_form.html'"></ng-include>
    </div>
  </div>
</page-data-manager>
